module.exports = __webpack_public_path__ + "media/images/challenges/sony-talent-league-edition-ii/banner--tribe_vote@2x-bf6cbb32f7d35ad6c07a2575f2ae0d96.jpg";